import React, { useState } from 'react';
import {
  Grid,
  Box,
  Dialog,
  AppBar,
  Toolbar,
  makeStyles,
  Theme,
  Typography,
  IconButton,
} from '@material-ui/core';
import { colors } from 'design-system';
import { XCircle } from 'react-feather';
import {
  Quotation,
  QuotationUnit,
  CoverageCatalog,
  CoverageCatalogResume,
} from 'data-layer-cr/dist/models';
import {
  PriceInformacionCard,
  VehicleInformationCard,
  BenefitsInformationCard,
  CoveragesInformationCard,
  MobilePriceCard,
} from '../InformationCards';

const DOLLAR_CURRENCY = '$';

const useStyles = makeStyles((theme: Theme) => ({
  contentWrappingDialog: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dialoguePaperStyle: {
    background: '#f9f9f9',
  },
  appDialogBar: {
    backgroundColor: colors.white,
  },
  appDialogBarOffset: theme.mixins.toolbar,
  closeIcon: {
    top: theme.spacing(2),
    right: theme.spacing(2),
    position: 'absolute',
  },
}));

type Props = {
  quotation: Quotation;
  paymentAmount: number;
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  additionalBenefits?: CoverageCatalog[];
};

const CollectiveMobileDisplay = ({
  quotation,
  paymentAmount,
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
  additionalBenefits,
}: Props): JSX.Element => {
  const classes = useStyles();
  const [showResume, setShowResume] = useState(false);
  const {
    summary: { carBrand, carModel, customerName },
  } = quotation;
  const carName = `${carBrand} ${carModel}`.toLowerCase();
  return (
    <>
      <Grid item xs={12}>
        <MobilePriceCard
          data-testid="mobile-price-card"
          customerName={customerName}
          vehicleData={carName}
          total={unit.total.grandTotal}
          numberOfPayments={paymentAmount}
          currency={quotation.quotationProfile.typeOfMoney || DOLLAR_CURRENCY}
          onShowQuotation={(): void => setShowResume(true)}
        />
      </Grid>

      <Dialog
        data-testid="summary-details-dialog"
        open={showResume}
        fullScreen
        PaperProps={{
          className: classes.dialoguePaperStyle,
        }}
      >
        <AppBar position="fixed" className={classes.appDialogBar} elevation={0}>
          <Toolbar>
            <Grid container justifyContent="center">
              <Grid item xs={12} container justifyContent="center">
                <Typography variant="body1" data-testid="details-title">
                  Cotización
                </Typography>
              </Grid>

              <Grid item xs={12} container justifyContent="center">
                <Typography variant="body1" data-testid="details-subtitle">
                  Cobertura Completa
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
          <IconButton
            data-testid="close-button"
            className={classes.closeIcon}
            onClick={(): void => setShowResume(false)}
          >
            <XCircle color={colors.madison} />
          </IconButton>
        </AppBar>

        <div className={classes.appDialogBarOffset} />
        <div className={classes.contentWrappingDialog}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box mb={3}>
                <VehicleInformationCard
                  data-testid="vehicle-information-card"
                  quotation={quotation}
                />
              </Box>

              <Box mb={3}>
                <PriceInformacionCard
                  data-testid="price-information-card"
                  title="Cotización"
                  quotation={quotation}
                  paymentAmount={paymentAmount}
                  unit={unit}
                  coverageCatalogs={coverageCatalogs}
                  coverageCatalogResumes={coverageCatalogResumes}
                />
              </Box>

              <Box mb={3}>
                <CoveragesInformationCard
                  data-testid="coverages-information-card"
                  quotation={quotation}
                  unit={unit}
                  coverageCatalogs={coverageCatalogs}
                  coverageCatalogResumes={coverageCatalogResumes}
                />
              </Box>

              <Box mb={3}>
                <BenefitsInformationCard
                  data-testid="benefits-information-card"
                  quotation={quotation}
                  productCoverages={unit.coverages}
                  coverageCatalogs={coverageCatalogs}
                  additionalBenefits={additionalBenefits}
                />
              </Box>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </>
  );
};

export default CollectiveMobileDisplay;
